


















import {Component, Mixins} from 'vue-property-decorator';
import {CommonModelUtils, FilterRetrieveResponse} from '@/model/CommonModel';
import CommonButton from '@/components/button/CommonButton.vue';
import TextInput from '@/components/input/TextInput.vue';
import BooleanCheckboxInput from '@/components/input/BooleanCheckboxInput.vue';
import UserApi from '@/api/UserApi';
import FilterMixin from '@/components/table/filter/FilterMixin';

@Component({
             components: {BooleanCheckboxInput, CommonButton, TextInput},
             mixins: [FilterMixin]
           })
export default class LikeAllFilter extends Mixins<FilterMixin>(FilterMixin) {
  private searchText: string = '';
  private checked: boolean = false;
  private readonly ALL: string = '[$ALL$]';
  private readonly FILTER_TYPE: string = 'LIKE_ALL';

  get isChecked() {
    return this.checked;
  }

  public onCheck() {
    this.checked = !this.checked;

    if (this.checked) {
      this.searchText = '';
    }
  }

  public loadFilter() {
    this.loading = true;
    UserApi.retrieveUserFilters(this.menuId, this.tableHeader.columnId)
           .then((res: FilterRetrieveResponse) => {
             const valueCode = CommonModelUtils.getOrDefault(res.data.filterList, [])[0].valueCode;
             if (valueCode === this.ALL) {
               this.checked = true;
             } else {
               this.searchText = valueCode;
             }
           })
           .finally(() => this.loading = false);
  }

  public onDone() {
    this.getFilterPromise(this.checked ? this.ALL : this.searchText)
        .then((res: any) => {
          this.visible = false;
          this.$emit('refresh');
        });
  }

  public getFilterPromise(valueCode: string) {
    if (!valueCode) {
      return UserApi.deleteUserFilters(this.menuId, this.tableHeader.columnId);
    } else {
      return UserApi.updateUserFilters(this.menuId, this.tableHeader.columnId, [{
        filterType: this.FILTER_TYPE,
        valueCode,
        valueCode2: ''
      }]);
    }
  }

  private onAfterLeave() {
    this.checked = false;
  }
}
